import { useNavigation } from '@react-navigation/native';
import React, { useCallback } from 'react';

import { LOG_TO_RELEASE } from '../../../actions/logs';
import { getConsentData } from '../../../agreementsConfig';
import {
    BigButton,
    Page,
    Text,
    View
} from '../../../common';
import { Log } from '../../../common/Log';
import { MODE } from '../../../config';
import {
    CHILD_CONSENT_LIST,
    usePersonalData,
    USER_CONSENT_LIST
} from '../../../hooks/usePersonalData';
import { COLORS } from '../../../styles/colors';

const getNextValue = (value) => {
    if (value === true) {
        return false;
    } else if (value === null || value === undefined) {
        return true;
    }
    return null;
};

const UserConsents = ({
    profileId,
    name,
    consents,
    onChangeConsent,
    providers,
}) => {
    console.log('!!!consent', {
        consents,
        providers,
        name,
        profileId,
    });
    const onChangeConsentHandler = useCallback((key, value, providerCode) => () => {
        const data = {
            profileId,
            providerCode,
            consent: { [key]: value },
            checkConsents: true,
        };
        console.log('!!!Change consent', data);
        onChangeConsent?.(data);
    }, [ onChangeConsent, profileId ]);

    return <View>
        <Text>{name} / {profileId}</Text>
        {Object.entries(consents)
            ?.map
            ?.(([ key, value ], index) => (<View
                key={`user${profileId}${index}`}
                style={{
                    flexDirection: 'row',
                    borderWidth: 1,
                    borderColor: COLORS.BORDER_GRAY,
                    flex: 1,
                    width: '100%',
                }}>
                <Text>{key}</Text>
                <View styles={{
                    alignItems: 'flex-end',
                    flex: 1,
                    borderWidth: 1,
                    borderColor: COLORS.RED,
                    width: '100%',
                }}>{Object.entries(value)
                        .map(([ key1, value1 ], idx) => (<BigButton
                            styles={{
                                flex: 1,
                                alignItems: 'flex-end',
                            }}
                            primary
                            title={`${key1}: ${value1}->${getNextValue(value1)}`}
                            action={onChangeConsentHandler(key1, getNextValue(value1), key === 'main' ? null : key)}
                            key={`button${profileId}${idx}${key}`}
                        />))}
                </View>
            </View>))
        }
    </View>;
};

export const TestConsentsScreen = Page.register(() => {
    const {
        consents,
        changeConsent,
        family,
        familyObject,
        isLoading,
        userInfo,
        providers,
        clinics,
        dispatch,
    } = usePersonalData();
    console.log('!!!all consents', consents);

    const changeConsentHandler = (data) => {
        dispatch(changeConsent(data));
    };

    return (MODE === 'qa' || LOG_TO_RELEASE) && (
        <Page scroll>
            <View styles={{
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
            }}>
                <View styles={{
                    flexDirection: 'column',
                }}>
                    <UserConsents
                        profileId={consents?.profileId}
                        name={userInfo?.name}
                        consents={consents?.user}
                        onChangeConsent={changeConsentHandler}/>
                    {Object.keys(consents?.family ?? {})
                        .map(profileId => (<UserConsents
                            profileId={profileId}
                            key={profileId}
                            name={familyObject?.[profileId]?.name || 'No Name'}
                            consents={consents?.family?.[profileId]}
                            onChangeConsent={changeConsentHandler}
                            providers={providers}/>))}
                </View>
            </View>
            {CHILD_CONSENT_LIST.map(c => getConsentData(c, clinics['tomography-minsk']?.name)?.TextData)}
            {USER_CONSENT_LIST.map(c => getConsentData(c, clinics['tomography-minsk']?.name)?.TextData)}
            <Log
                value={{
                    // consents,
                    // familyObject,
                    providers,
                    clinics,
                    consents,
                }}
                pre
                text={'CONSENTS LOG'}/>

            {/* <Log */}
            {/*     display={true} */}
            {/*     value={{ */}
            {/*         consents, */}
            {/*         familyObject, */}
            {/*         isLoading, */}
            {/*     }} */}
            {/*     text={'Consents data'} */}
            {/*     pre/> */}
        </Page>);
});

export const TestConsentsButton = ({ hide }) => {
    const navigation = useNavigation();
    return (
        (MODE === 'qa' || LOG_TO_RELEASE) &&
        !hide && (
            <BigButton
                title="Consents"
                styles={[
                    {
                        borderWidth: 1,
                        borderColor: COLORS.BORDER_GRAY,
                        backgroundColor: COLORS.POSITIVE,
                        color: COLORS.LIGHT_GRAY,
                        padding: 4,
                    },
                ]}
                action={() => {
                    navigation.navigate('TestConsentsScreen');
                }}
            />
        )
    );
};
